<script lang="typescript">
    export let text: string = "Body 2/Roboto/Regular/14px";
    export let color = "var(--color-level-6)";
</script>

<span style="color: {color};" class="caption">{text}</span>

<style>
    .caption {
        /* Caption */

        /* Caption */
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        /* identical to box height, or 133% */
        letter-spacing: 0.4px;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
